import React from "react";
import Footer from "./Footer";
// Home / Orders
import Reports from "../Components/Reports/Reports";
import TakeOrder from "../Components/TakeOrder/TakeOrder";
import Orders from "../Components/Orders/Orders";
// Expenses
import ExpensesContainer from "../Components/ExpensesStore/ExpensesContainer";
import ExpensesReportcontainer from "./Expenses Reports/ExpensesReportcontainer";
import Expenses from "../Components/Expenses";
// Vendors 
import VendorContainer from "../Components/Vendors";
import VendorInvoiceContainer from "../Components/VendorInvoices";
import VendorPaymentContainer from "../Components/VendorPayment";
// Reports
import ItemReports from "../Components/ItemReports";
import CategoryReports from "../Components/CategoryReports";
import BillReports from "../Components/BillReports";
import VendorReportContainer from "../Components/VendorReport/VendorReportContainer";
import ExecutiveReports from "../Components/ExecutiveReports";
import TodaysReport from "../Components/TodaysReport";

import logo from "../images/logo.png";
class ShopDash extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Main pages
      home: true,
      takeOrder: false,
      orders: false,
      // Vendors
      vendors: false,
      vendorInvoices: false,
      vendorPayments: false,
      // Reports
      superAdminReports: false,
      expensesReport: false,
      vendorReport: false,
      itemReports: false,
      categoryReports: false,
      billReports: false,
      execReports: false,
      hourlyReports: false,
      // Expenses
      expensesMain: false,
      expenseReport: false,
      expensesItems: false,
      expenseCat: false,
      expenseSubCat: false,
      // Sidebar dropdowns
      vendorsMenuOpen: false,
      reportsMenuOpen: false,
      expensesMenuOpen: false,
    };
  }
  // =========================================================
  // COMMON RESET
  // =========================================================
  resetPages = () => {
    return {
      home: false,
      takeOrder: false,
      orders: false,

      vendors: false,
      vendorInvoices: false,
      vendorPayments: false,

      superAdminReports: false,
      expensesReport: false,
      vendorReport: false,
      itemReports: false,
      categoryReports: false,
      billReports: false,
      execReports: false,
      hourlyReports: false,

      expensesMain: false,
      expenseReport: false,
      expensesItems: false,
      expenseCat: false,
      expenseSubCat: false,
    };
  };
  // =========================================================
  // SIDEBAR DROPDOWN TOGGLE
  // =========================================================
  toggleVendorsMenu = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      vendorsMenuOpen: !prevState.vendorsMenuOpen,
    }));
  };
  toggleReportsMenu = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      reportsMenuOpen: !prevState.reportsMenuOpen,
    }));
  };
  toggleExpensesMenu = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      expensesMenuOpen: !prevState.expensesMenuOpen,
    }));
  };
  // =========================================================
  // HOME
  // =========================================================
  showHome = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      home: true,
    });
  };
  // =========================================================
  // TAKE ORDER
  // =========================================================
  showTakeOrder = (e) => {
    e.preventDefault();

    this.setState({
      ...this.resetPages(),
      takeOrder: true,
    });
  };
  // =========================================================
  // ORDERS
  // =========================================================
  showOrders = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      orders: true,
    });
  };
  // =========================================================
  // VENDORS
  // =========================================================
  showVendors = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      vendors: true,
      vendorsMenuOpen: true,
    });
  };
  showVendorInvoices = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      vendorInvoices: true,
      vendorsMenuOpen: true,
    });
  };
  showVendorPayments = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      vendorPayments: true,
      vendorsMenuOpen: true,
    });
  };
  // =========================================================
  // REPORTS
  // =========================================================
  showSuperAdminReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      superAdminReports: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminExpensesReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expensesReport: true,
      reportsMenuOpen: true,
    });
  };
  showVendorReport = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      vendorReport: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminItemReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      itemReports: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminCategoryReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      categoryReports: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminBillReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      billReports: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminExecReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      execReports: true,
      reportsMenuOpen: true,
    });
  };
  showSuperAdminHourlyReports = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      hourlyReports: true,
      reportsMenuOpen: true,
    });
  };
  // =========================================================
  // EXPENSES
  // =========================================================
  showExpensesMain = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expensesMain: true,
      expensesMenuOpen: true,
    });
  };
  showExpenseItems = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expensesItems: true,
      expensesMenuOpen: true,
    });
  };
  showExpenseCategories = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expensesItems: true,
      expenseCat: true,
      expensesMenuOpen: true,
    });
  };
  showExpenseSubCategories = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expensesItems: true,
      expenseSubCat: true,
      expensesMenuOpen: true,
    });
  };
  showExpenseReport = (e) => {
    e.preventDefault();
    this.setState({
      ...this.resetPages(),
      expenseReport: true,
      expensesMenuOpen: true,
    });
  };
  // =========================================================
  // RENDER
  // =========================================================
  render() {
    const userCheck = window.localStorage.getItem("access");
    let user = {};
    try {
      user = userCheck ? JSON.parse(userCheck) : {};
    } catch (error) {
      user = {};
    }
    return (
      <div className="page-content d-flex align-items-stretch">
        {/* =====================================================
            SIDEBAR
        ====================================================== */}
        <nav className="side-navbar">
          {/* USER PROFILE */}
          <div className="sidebar-header d-flex align-items-center">
            <div className="avatar">
              <img
                src={logo}
                alt="Logo"
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="title">
              <h1 className="h4">
                {user.name || "User"}
              </h1>
              <p>
                {user.role || ""}
              </p>
            </div>
          </div>
          <ul className="list-unstyled">
            {/* =================================================
                HOME
            ================================================== */}
            <li
              onClick={this.showHome}
              className={this.state.home ? "active" : null}
            >
              <a href="#/">
                <i className="icon-home"></i>
                Home
              </a>
            </li>
            {/* =================================================
                  TAKE ORDER
            ================================================== */}
            <li
              onClick={this.showTakeOrder}
              className={this.state.takeOrder ? "active" : null}
            >
              <a href="#/">
                <i className="icon-grid"></i>
                Take Order
              </a>
            </li>
            {/* =================================================
                ORDERS
            ================================================== */}
            <li
              onClick={this.showOrders}
              className={this.state.orders ? "active" : null}
            >
              <a href="#/">
                <i className="icon-grid"></i>
                Orders
              </a>
            </li>
            {/* =================================================
                VENDORS
            ================================================== */}
            <li>
              <a
                href="#vendors"
                onClick={this.toggleVendorsMenu}
                aria-expanded={this.state.vendorsMenuOpen}
              >
                <i className="fa fa-money"></i>
                Vendors
                <span style={{ float: "right" }}>
                  {this.state.vendorsMenuOpen ? "▲" : "▼"}
                </span>
              </a>
              {this.state.vendorsMenuOpen && (
                <ul className="list-unstyled">
                  {/* Add Vendors */}
                  <li
                    onClick={this.showVendors}
                    className={
                      this.state.vendors ? "active" : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-grid"></i>
                      Add Vendors
                    </a>
                  </li>
                  {/* Invoices */}
                  <li
                    onClick={this.showVendorInvoices}
                    className={
                      this.state.vendorInvoices ? "active" : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Invoices
                    </a>
                  </li>
                  {/* Payments */}
                  <li
                    onClick={this.showVendorPayments}
                    className={
                      this.state.vendorPayments ? "active" : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-list-alt"></i>
                      Payments
                    </a>
                  </li>
                </ul>
              )}
            </li>
            {/* =================================================
                REPORTS
            ================================================== */}
            <li>
              <a
                href="#reports"
                onClick={this.toggleReportsMenu}
                aria-expanded={this.state.reportsMenuOpen}
              >
                <i className="fa fa-file-text"></i>
                Reports
                <span style={{ float: "right" }}>
                  {this.state.reportsMenuOpen ? "▲" : "▼"}
                </span>
              </a>
              {this.state.reportsMenuOpen && (
                <ul className="list-unstyled">
                  {/* Analytics */}
                  <li
                    onClick={this.showSuperAdminReports}
                    className={
                      this.state.superAdminReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-bar-chart"></i>
                      Analytics
                    </a>
                  </li>
                  {/* Expenses Report */}
                  <li
                    onClick={this.showSuperAdminExpensesReports}
                    className={
                      this.state.expensesReport
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Expenses Report
                    </a>
                  </li>
                  {/* Vendor Report */}
                  <li
                    onClick={this.showVendorReport}
                    className={
                      this.state.vendorReport
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-users"></i>
                      Vendor Report
                    </a>
                  </li>
                  {/* Item Wise Reports */}
                  <li
                    onClick={this.showSuperAdminItemReports}
                    className={
                      this.state.itemReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Item Wise Reports
                    </a>
                  </li>
                  {/* Category Reports */}
                  <li
                    onClick={this.showSuperAdminCategoryReports}
                    className={
                      this.state.categoryReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-list-alt"></i>
                      Category Reports
                    </a>
                  </li>
                  {/* Bill Wise Reports */}
                  <li
                    onClick={this.showSuperAdminBillReports}
                    className={
                      this.state.billReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Bill Wise Reports
                    </a>
                  </li>
                  {/* Executive Reports */}
                  <li
                    onClick={this.showSuperAdminExecReports}
                    className={
                      this.state.execReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Executive Reports
                    </a>
                  </li>
                  {/* Hourly Reports */}
                  <li
                    onClick={this.showSuperAdminHourlyReports}
                    className={
                      this.state.hourlyReports
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Hourly Reports
                    </a>
                  </li>
                </ul>
              )}
            </li>
            {/* =================================================
                EXPENSES
            ================================================== */}
            <li>
              <a
                href="#expenses"
                onClick={this.toggleExpensesMenu}
                aria-expanded={this.state.expensesMenuOpen}
              >
                <i className="fa fa-money"></i>
                Expenses
                <span style={{ float: "right" }}>
                  {this.state.expensesMenuOpen ? "▲" : "▼"}
                </span>
              </a>
              {this.state.expensesMenuOpen && (
                <ul className="list-unstyled">
                  {/* Add Expenses */}
                  <li
                    onClick={this.showExpensesMain}
                    className={
                      this.state.expensesMain
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-money"></i>
                      Add Expenses
                    </a>
                  </li>
                  {/* Add Expense Items */}
                  <li
                    onClick={this.showExpenseItems}
                    className={
                      this.state.expensesItems
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="fa fa-list-alt"></i>
                      Add Expense Items
                    </a>
                  </li>
                  {/* Expense Reports */}
                  <li
                    onClick={this.showExpenseReport}
                    className={
                      this.state.expenseReport
                        ? "active"
                        : null
                    }
                  >
                    <a href="#/">
                      <i className="icon-padnote"></i>
                      Expense Reports
                    </a>
                  </li>
                </ul>
              )}
            </li>
          </ul>
          <span className="heading"></span>
        </nav>
        {/* =====================================================
            CONTENT
        ====================================================== */}
        <div className="content-inner">
          {/* HOME */}
          {this.state.home && <Reports />}
          {/* TAKE ORDER */}
          {this.state.takeOrder && <TakeOrder />}
          {/* ORDERS */}
          {this.state.orders && <Orders />}
          {/* =================================================
              VENDORS
          ================================================== */}
          {this.state.vendors && (
            <VendorContainer />
          )}
          {this.state.vendorInvoices && (
            <VendorInvoiceContainer />
          )}
          {this.state.vendorPayments && (
            <VendorPaymentContainer />
          )}
          {/* =================================================
              REPORTS
          ================================================== */}
          {this.state.superAdminReports && (
            <Reports />
          )}
          {this.state.expensesReport && (
            <ExpensesReportcontainer />
          )}
          {this.state.vendorReport && (
            <VendorReportContainer />
          )}
          {this.state.itemReports && (
            <ItemReports />
          )}
          {this.state.categoryReports && (
            <CategoryReports />
          )}
          {this.state.billReports && (
            <BillReports />
          )}
          {this.state.execReports && (
            <ExecutiveReports />
          )}
          {this.state.hourlyReports && (
            <TodaysReport />
          )}
          {/* =================================================
              EXPENSES
          ================================================== */}
          {this.state.expensesMain && (
            <ExpensesContainer />
          )}
          {this.state.expensesItems && (
            <Expenses
              expenses={this.state.expensesItems}
              expenseCat={this.state.expenseCat}
              expenseSubCat={this.state.expenseSubCat}
            />
          )}
          {this.state.expenseReport && (
            <ExpensesReportcontainer />
          )}
          <Footer />
        </div>
      </div>
    );
  }
}
export default ShopDash;